import(/* webpackMode: "eager", webpackExports: ["ContatoForm"] */ "/app/app/(public)/contato/contato-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContatoWhatsApp"] */ "/app/app/(public)/contato/contato-whatsapp.tsx");
